import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #212121;

  position: fixed;
  z-index: 999;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20;

  & .iconImage {
    font-size: 109px;
    color: #dcc6b7;
  }

  padding-left: 24px;
  padding-right: 24px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #dcc6b7;
  margin-bottom: 36px;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 36px;
  line-height: 1.3;
`;

export const ButtonContainer = styled.div`
  width: 500px;
  margin-top: 18px;

  @media screen and (max-width: 720px) {
    width: 100%;
  }
`;
